/**
 * tabslider/frontend.js
 * 
 * @author jjarolim
 */

import $ from 'jquery';

const debounce = (func, timeout = 300, callback = undefined) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { 
            func.apply(this, args); 
            if ( callback !== undefined ) {
                callback();
            }
        }, timeout);
    };
}


const detectSingleLineDisplay = ( $tabslider ) => {

    $( '.tabslider__navigation', $tabslider ).each( function() {

        // Detect y position of first li element in page

        const $firstLi = $( 'li:first-child', this )
        const firstLiTop = $firstLi.offset().top

        // Cylcle over all li elements: If one li element has a 
        // different y position, the li elements are displayed in multiple lines

        let isSingleLine = true

        $( 'li', this ).each( function() {
                
            const $li = $( this );
            const liTop = $li.offset().top

            if ( liTop !== firstLiTop ) {
                isSingleLine = false
            }
    
        } );

        if ( isSingleLine ) {
            $tabslider.removeClass( 'is-multi-line' )
            $tabslider.addClass( 'is-single-line' )
        } else {
            $tabslider.removeClass( 'is-single-line' )
            $tabslider.addClass( 'is-multi-line' )
        }

    } );

}


const initializeTabslider = () => {

    // On Document Ready

    $( function() {

        // Each Tabslider

        $( '.block__tabslider' ).each( function() {

            const $tabslider = $( this );

            // Initialize single line detection

            detectSingleLineDisplay( $tabslider );
            $( window ).on( 'resize', debounce( () => detectSingleLineDisplay( $tabslider ), 50 ) );

            // count the slides to handle tabsliders with only one slide and to
            // set the correct target slide for prev and next buttons
            const slideCount = $( '.tabslider__prev', $tabslider ).length

            // prev's target is always current one - 1
            $( '.tabslider__prev', $tabslider ).each( function(i) {
                if (slideCount === 1) {
                    $( this ).remove()
                    return
                }
                $( this ).attr('data-targetslide', i-1)
            });

            // next's target is always current one + 1, except for the last one
            $( '.tabslider__next', $tabslider ).each( function(i) {
                if (slideCount === 1) {
                    $( this ).remove()
                    return
                }
                $( this ).attr('data-targetslide', i < slideCount - 1 ? (i + 1) : 0)
            });

            // click on prev and next buttons triggers click on the
            // corresponding navigation element
            $( '.tabslider__prev, .tabslider__next', $tabslider ).on( 'click', function( e ) {
                e.preventDefault()

                let target_id = $( this ).attr( 'data-targetslide' )
                if (target_id === undefined) return
                if (target_id < 0) {
                    target_id = $( '.block__tabslider_tab', $tabslider ).length -1
                }

                // korrekte markierung der navigation, wenns eine gibt
                const $nav = $( '.tabslider__navigation li a', $tabslider )

                if ( $nav.length > 0 ) {
                    $nav.eq(target_id).trigger('click')
                } else {

                    // wenns keine nav gibt, manuell die slides switchen
                    const $slides = $( '.block__tabslider_tab', $tabslider )
                    // alle ausblenden
                    $slides.hide()
                    // nur das target einblenden
                    $slides.each( function( index ) {
                        if ( index == target_id ) {
                            $( this ).fadeIn(500);
                        }
                    })
                }
            });


            // Each Navigation Element

            $( '.tabslider__navigation li', this ).each( function() {

                const $li = $( this );

                // On Click

                $( 'a', $li ).on( 'click', function( e ) {

                    e.preventDefault();

                    // Reset Active Class

                    $( '.tabslider__navigation li a', $tabslider ).addClass( 'decoration-white' );
                    $( '.tabslider__navigation li a', $tabslider ).removeClass( 'decoration-primary' );
                    $( 'a', $li).removeClass( 'decoration-white' );
                    $( 'a', $li).addClass( 'decoration-primary' );

                    
                    // Hide active Panel and fadeIn new Panel

                    const target_id = $( this ).attr( 'href' );

                    $( '.block__tabslider_tab', $tabslider ).hide();
                    $( target_id, $tabslider ).hide().fadeIn( 500 );

                    // XS/SM: Scroll to active panel

                    const $parent = $( this ).closest( '.block__tabslider' );
                    const isSingleLine = $parent.hasClass( 'is-single-line' );

                    if ( ! isSingleLine ) {

                        const scrollTarget = $( target_id ).offset().top - 200;

                        $( 'html, body' ).animate( {
                            scrollTop: scrollTarget
                        }, 500 );

                    }

                } );


            } );



        } );

    } );

}

initializeTabslider();